import Employment from "@/model/Employment";
import moment from "moment";
import {EmploymentPeriodV3Dto} from "@/service/EmployeeService";

export default {
  /**
   * Maps the employment periods of the v3 employee API onto {@link Employment}s, oldest first as the other functions
   * expect them - the v3 API returns them newest first.
   */
  fromEmploymentPeriodsV3 (employmentPeriods: Array<EmploymentPeriodV3Dto>): Array<Employment> {
    return employmentPeriods
      .map(employmentPeriod => Object.assign(new Employment(), {
        uuid: employmentPeriod.id,
        employmentType: employmentPeriod.employmentType,
        validFrom: employmentPeriod.validFrom,
        validTo: employmentPeriod.validTo
      }))
      .reverse();
  },
  getCurrentEmployment (employments: Array<Employment>): Employment {
    const currentEmployment = employments.find(employment => {
      const validFromIsSameOrBeforeCurrentMonth = moment(employment.validFrom).isSameOrBefore(moment().startOf("month"));
      const validToIsSameOrAfterCurrentDay = !employment.validTo || moment(employment.validTo).isSameOrAfter(moment(), "day");
      return validFromIsSameOrBeforeCurrentMonth && validToIsSameOrAfterCurrentDay;
    });

    return Object.assign(new Employment(), currentEmployment) || new Employment();
  },
  // Employments are matched by their start date, as no two employments of an employee start on the same day and v3
  // employments have no numeric id
  getNextEmployment (employments: Array<Employment>): Employment | null {
    const currentEmployment = this.getCurrentEmployment(employments);
    const indexCurrentEmployment = employments.findIndex(emp => emp.validFrom === currentEmployment.validFrom);
    if (employments.length > indexCurrentEmployment + 1) {
      return Object.assign(new Employment(), employments[indexCurrentEmployment + 1]);
    } else {
      return null;
    }
  },
  getFutureEmployments (employments: Array<Employment>): Array<Employment> {
    let futureEmployments = new Array<Employment>();
    const nextEmployment = this.getNextEmployment(employments);
    if (nextEmployment != null) {
      const indexNextEmployment = employments.findIndex(emp => emp.validFrom === nextEmployment.validFrom);
      if (employments.length > indexNextEmployment + 1) {
        futureEmployments = employments.slice(indexNextEmployment + 1);
      }
    }

    return futureEmployments;
  }
};
